"use strict";

var _classCallCheck = require("/app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var AssetEmbedderOptions_1 = require("./AssetEmbedderOptions");

var HtmlDOMParser_1 = require("./HtmlDOMParser");

var VideoEmbedders_1 = require("./videoembedders/VideoEmbedders");

var AssetEmbedder =
/*#__PURE__*/
function () {
  function AssetEmbedder(options, localization) {
    _classCallCheck(this, AssetEmbedder);

    AssetEmbedderOptions_1.AssetEmbedderOptions.validate(options);
    this.options = options;
    this.localization = localization;
  }

  _createClass(AssetEmbedder, [{
    key: "markAssets",
    value: function markAssets(input) {
      var parser = new HtmlDOMParser_1.HtmlDOMParser(this.options, this.localization);
      return parser.parse(input).getParsedDocumentAsString();
    }
  }, {
    key: "insertAssets",
    value: function insertAssets(input) {
      var size = {
        width: this.options.width,
        height: this.options.height
      };
      return VideoEmbedders_1.VideoEmbedders.insertMarkedEmbedsToRenderedOutput(input, size);
    }
  }]);

  return AssetEmbedder;
}();

exports.AssetEmbedder = AssetEmbedder;